import { Box, Typography } from '@mui/material'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { getMyProfile, logout, qk, resendConfirmationEmail } from 'api'
import { useAuthContext } from 'app/auth'
import { paths } from 'app/routes'
import { Dialog, DialogContent } from 'elements/feedback'
import { Button } from 'elements/inputs'
import { useBoolean } from 'lib/hooks'
import { Trans, useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export const UnconfirmedEmailChecker = () => {
  const { t } = useTranslation()

  const queryClient = useQueryClient()

  const navigate = useNavigate()

  const { unauthorize } = useAuthContext()

  const emailSent = useBoolean(false)

  const $logout = useMutation(logout)

  const $resendConfirmationEmail = useMutation(resendConfirmationEmail)

  const { data } = useQuery(qk.users.myProfile.toKey(), getMyProfile)

  if (!data) return null

  if (data.status === 'pending') {
    return (
      <Dialog open size="small">
        {emailSent.isTrue ? (
          <Typography variant="caption1" p={3} textAlign="center">
            <Trans i18nKey="sign_up.confirm_email_description" />
          </Typography>
        ) : (
          <DialogContent
            title={t('sign_up.confirm_email_to_proceed')}
            hideCrossIcon
            centerTitle
          >
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              flexDirection="column"
              py={2}
            >
              <Button
                onClick={() =>
                  $resendConfirmationEmail.mutate(undefined, {
                    onSuccess: emailSent.setTrue,
                  })
                }
                sx={{ mb: 2 }}
              >
                {t('sign_up.resend_confirmation')}
              </Button>

              <Button
                variant="text"
                onClick={() => {
                  $logout.mutate(undefined, {
                    onSuccess: () => {
                      unauthorize()
                      queryClient.removeQueries()
                      navigate(paths.signIn)
                    },
                  })
                }}
              >
                {t('common.log_out')}
              </Button>
            </Box>
          </DialogContent>
        )}
      </Dialog>
    )
  }

  return null
}
